export default function User(state = {open:true,conversation:null,users:[],loadUsers:false},action){

	if(action.type === "OPEN_CHAT"){ 
        
        state = JSON.parse(JSON.stringify(state));
        state.open = true; 
    
    }

	if(action.type === "CLOSE_CHAT"){ 
        
        state = JSON.parse(JSON.stringify(state));
        state.open = false; 

    }

    //Para listar meus contatos
    if(action.type === "LIST_FRIENDS"){ 
        
        state = JSON.parse(JSON.stringify(state));
        state.conversation = null; 

    }

    //Para iniciar uma conversa com alguem

    if(action.type === "INIT_CONVERSATION"){ 
        
        state = JSON.parse(JSON.stringify(state));
        state.conversation = action.data.user; 
        state.open = true; 

    }

    //Para colocar todos os usuarios no chat
    if(action.type === "SET_CHAT_USERS"){ 
        
        state = JSON.parse(JSON.stringify(state));
        state.users = action.data;
        state.loadUsers = true; 

    }

 	/*if(action.type === "SET_DATA_SET_PREFERENCE_MODAL_BASIC_CHART_USER"){ 

		state = JSON.parse(JSON.stringify(state));
		if(state.preference !== undefined){

			state.preference.modalbasicchartuser = action.data;

		}
		
	}*/

 

	return state;

}